import { Ticker } from "pixi.js";
import { BaseMole } from "../BaseMole";
import { MoleAnimationController, MoleAnimationState } from "../MoleAnimationController";
import { DieState } from "./DieState";
import { FreezeState } from "./FreezeState";
import { IMoleState } from "./IMoleState";

export class IdleTimeoutState implements IMoleState {
    private currentTimeout: number;

    public constructor(
        private readonly mole: BaseMole,
        private readonly animationController: MoleAnimationController,
        private readonly afterIdleState: IMoleState,
        private readonly dieState: DieState,
        private readonly freezeState: FreezeState,
        idleTimeout: number
    ) {
        this.currentTimeout = idleTimeout;
    }

    public enter(previousState: IMoleState): void {
        this.animationController.onClipEnd.add(this.handleClipEnd, this);
        if (!(previousState instanceof FreezeState)) {
            this.animationController.transitToState(MoleAnimationState.Idle);
        }
    }

    private handleClipEnd(_state: MoleAnimationState): void {
        this.animationController.transitToState(MoleAnimationState.Idle);
    }

    public exit(): void {
        this.animationController.onClipEnd.remove(this.handleClipEnd, this);
    }

    public process(deltaMS: number): IMoleState {
        if (!this.mole.alive) {
            return this.dieState;
        }
        if (this.mole.freezed) {
            return this.freezeState;
        }
        this.currentTimeout = Math.max(this.currentTimeout - deltaMS, 0);
        if (this.currentTimeout == 0) {
            return this.afterIdleState;
        }
        return this;
    }

}